import { render, staticRenderFns } from "./ReviewStep.vue?vue&type=template&id=afc399ac&scoped=true"
import script from "./ReviewStep.vue?vue&type=script&lang=js"
export * from "./ReviewStep.vue?vue&type=script&lang=js"
import style0 from "./ReviewStep.vue?vue&type=style&index=0&id=afc399ac&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc399ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('afc399ac')) {
      api.createRecord('afc399ac', component.options)
    } else {
      api.reload('afc399ac', component.options)
    }
    module.hot.accept("./ReviewStep.vue?vue&type=template&id=afc399ac&scoped=true", function () {
      api.rerender('afc399ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/catalog/ReviewStep.vue"
export default component.exports